import { logDebug } from "../LocalLogger";
import { appStore } from "../utils/AppMobx";
import { localLargeStorage } from "../utils/LocalLargeStorage";
import { Utils } from "../utils/utils";

export interface ProductType {
	id: string;
	title: string;
	description: string;
	tags: string[];
	options?: ProductOption[];
	variants: ProductVariant[];
	images?: ProductImage[];
	created_at: string;
	updated_at: string;
	visible: boolean;
	is_locked: boolean;
	blueprint_id: number;
	user_id: number;
	shop_id: number;
	print_provider_id: number;
	print_areas: PrintArea[];
	print_details: any[];
	sales_channel_properties: any[];
	is_printify_express_eligible: boolean;
	is_printify_express_enabled: boolean;
	is_economy_shipping_eligible: boolean;
	is_economy_shipping_enabled: boolean;
	is_deleted: boolean;
	original_product_id: string;
	views: ProductView[];
	per_cost?: ProductVariant[];
}

export interface ProductOption {
	name: string;
	type: string;
	values: OptionValue[];
	display_in_preview: boolean;
}

export interface OptionValue {
	used?: boolean;
	id: number;
	title: string;
	colors?: string[];
	type?: string;
}

export interface ProductVariant {
	image: string;
	id: number;
	sku: string;
	cost: number;
	price: number;
	title: string;
	grams: number;
	is_enabled: boolean;
	is_default: boolean;
	is_available: boolean;
	is_printify_express_eligible: boolean;
	options: number[] | OptionValue[];
	quantity: number;
}

export interface ProductImage {
	src: string;
	variant_ids: number[];
	position: string;
	is_default: boolean;
	is_selected_for_publishing: boolean;
	order: number | null;
}

export interface PrintArea {
	variant_ids: number[];
	placeholders: PrintPlaceholder[];
	background: string;
}

export interface PrintPlaceholder {
	position: string;
	images: PrintImage[];
}

export interface PrintImage {
	id: string;
	name: string;
	type: string;
	height: number;
	width: number;
	x: number;
	y: number;
	scale: number;
	angle: number;
	src: string;
}

export interface ProductView {
	id: number;
	label: string;
	position: string;
	files: ProductViewFile[];
}

export interface ProductViewFile {
	src: string;
	variant_ids: number[];
}
let _colorsMap: any = {};
export async function getColorsMap() {
	if (Object.keys(_colorsMap).length > 0) {
		return _colorsMap;
	}
	const colors = await localLargeStorage.getItem("colorsMap");
	if (colors) {
		try {
			_colorsMap = JSON.parse(colors);
		} catch (e) {
			logDebug("Error parsing colorsMap from local storage", e);
			_colorsMap = {};
		}
	} else {
		alert("No colors found in local storage, please generate.");
	}
	return _colorsMap;
}
export async function fixProduct(product: ProductType): Promise<ProductType> {
	const colors = (await localLargeStorage.getItem("colors")) || ({} as any);
	const curLength = Object.keys(colors).length;
	const flatMap =
		product.options?.flatMap((opt) => {
			if (opt.type === "color" && opt.values) {
				opt.values.forEach((value) => {
					colors[value.title] = value.colors?.[0] || "#FF00FF"; // Default to magenta if no color is provided
				});
			}
			const type = opt.type;
			opt.values.forEach((value) => {
				value.type = type;
			});
			return opt.values;
		}) ?? [];
	if (Object.keys(colors).length > curLength) {
		logDebug("Saving colors to local storage", colors);
		await localLargeStorage.setItem("colorsMap", JSON.stringify(colors));
		_colorsMap = colors;
	}
	const realMap = {} as Record<number, OptionValue>;
	flatMap.forEach((option) => {
		realMap[option.id] = option;
	});
	// debugger;
	product.variants = product.variants.map((variant) => {
		variant.image = product.images?.find((image) => image.variant_ids.includes(variant.id) && image.is_default)?.src || "";
		// if (!variant.image) {
		// 	variant.is_available = false; // If no image, mark as unavailable
		// }
		variant.options = variant.options.map((optionId) => {
			if (realMap[optionId as number]) {
				const option = realMap[optionId as number];
				option.used = option.used || variant.is_available; // Mark as used if it has an image
				return Utils.clone(option);
			}
		});

		return variant;
	});

	// get one for each unique cost
	product.per_cost = product.variants.reduce((acc: ProductVariant[], variant) => {
		if (!variant.image || !variant.is_available || !variant.is_enabled) {
			return acc;
		}
		if (!acc.some((v) => v.cost === variant.cost)) {
			acc.push(variant);
		}
		return acc;
	}, []);
	delete product.images;
	// delete product.options;
	return product;
}
